module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wymagane",
      "error": _vm.errors['required']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form['required']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'required', $$v)
      },
      expression: "form['required']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Pole od krawędzi do krawędzi",
      "error": _vm.errors.full_width
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.full_width),
      callback: function($$v) {
        _vm.$set(_vm.form, "full_width", $$v)
      },
      expression: "form.full_width"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nazwa pola",
      "error": _vm.errors[_vm.addLanguageSuffix('label')],
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Nazwa pola"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('label')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('label'), $$v)
      },
      expression: "form[addLanguageSuffix('label')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Placeholder",
      "error": _vm.errors[_vm.addLanguageSuffix('placeholder')]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Placeholder"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('placeholder')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('placeholder'), $$v)
      },
      expression: "form[addLanguageSuffix('placeholder')]"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2df70aed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/forms/BaseField.vue
// module id = 730
// module chunks = 0